import { ComponentPropsWithoutRef } from "react";
import cn from "../util/cn";

type MaterialIconProps = {
  iconName: string;
} & Omit<ComponentPropsWithoutRef<"span">, "children">;

const MaterialIcon = ({ iconName, className, ...otherProps }: MaterialIconProps) => {
  return (
    <span className={cn("material-icons", className)} {...otherProps}>
      {iconName}
    </span>
  );
};

export default MaterialIcon;
